module.exports = __webpack_public_path__ + "static/media/36-5.29d6e512.mp3";